<div class="center_column">

  @if (stepper.registrierungAbgeschlossen()) {
    <div class="banner_column">
      {{'registrierung.zusammenfassung.fast_geschafft' | translate}}
    </div>

    <div class="illustration_background">
      <img ngSrc="/assets/illustration_mail.svg" alt="Abschluss mit Mail" width="172" height="86" priority/>
    </div>
    <br />
    <br />
    <div class="banner_column_small">
      {{'registrierung.zusammenfassung.hinweis_mail' | translate}}
    </div>
  }

</div>






